export type BriteSurface = 'profile-settings' | 'bank-info-modal' | 'onboarding-bank' | 'legacy-bank-info' | 'invoice-config';

export interface BritePendingFlow {
  token: string;
  sessionId: string;
  surface: BriteSurface;
  createdAt: number;
}

const STORAGE_KEY = 'brite_pending_flow';

const MAX_FLOW_AGE_MS = 28 * 60 * 1000;

export function saveBritePendingFlow(flow: BritePendingFlow): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(flow));
  } catch {
  }
}

export function readBritePendingFlow(): BritePendingFlow | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const flow = JSON.parse(raw) as BritePendingFlow;
    if (!flow?.token || !flow?.sessionId || !flow?.surface || !flow?.createdAt) return null;
    if (Date.now() - flow.createdAt > MAX_FLOW_AGE_MS) {
      clearBritePendingFlow();
      return null;
    }
    return flow;
  } catch {
    return null;
  }
}

export function clearBritePendingFlow(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
  
  }
}

function buildCallbackUrl(status: 'complete' | 'resume', surface: BriteSurface): string {
  const url = new URL(window.location.href);
  url.searchParams.set('briteStatus', status);
  url.searchParams.set('briteSurface', surface);

  if (surface === 'profile-settings') {
    url.searchParams.set('tab', 'bank');
  }
  return url.toString();
}

export function buildBriteCallbackUrls(surface: BriteSurface): { redirectUri: string; deeplinkRedirect: string } {
  return {
    redirectUri: buildCallbackUrl('complete', surface),
    deeplinkRedirect: buildCallbackUrl('resume', surface),
  };
}
export interface BriteReturnIntent {
  status: 'complete' | 'resume';
  flow: BritePendingFlow;
}

export function hasPendingBriteReturn(surface: BriteSurface): boolean {
  const status = new URLSearchParams(window.location.search).get('briteStatus');
  if (status !== 'complete' && status !== 'resume') return false;
  const flow = readBritePendingFlow();
  return flow?.surface === surface;
}

export function readBriteReturnIntent(expectedSurface: BriteSurface): BriteReturnIntent | null {
  const params = new URLSearchParams(window.location.search);
  const status = params.get('briteStatus');
  const surfaceParam = params.get('briteSurface');
  if (status !== 'complete' && status !== 'resume') return null;
  if (surfaceParam !== expectedSurface) return null;

  const flow = readBritePendingFlow();
  if (!flow || flow.surface !== expectedSurface) return null;

  const url = new URL(window.location.href);
  url.searchParams.delete('briteStatus');
  url.searchParams.delete('briteSurface');
  window.history.replaceState({}, '', url.toString());

  return { status, flow };
}
